import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import "../css/DepositHistory.css";
import "../css/mainhome.css";
import AppHeader from "../components/AppHeader";

export default function WithdrawHistoryScreen() {
  const navigate = useNavigate();

  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  const walletBalance = localStorage.getItem("walletBalance");

  useEffect(() => {
    const fetchWithdrawals = async () => {
      try {
        const registerId = localStorage.getItem("registerId");

        if (!registerId) {
          alert("Missing registerId.");
          setLoading(false);
          return;
        }

        const res = await apiClient.post(
          "/withdrawal-fund-history",
          {
            registerId,
            pageIndex: 1,
            recordLimit: 999,
          }
        );

        const list = res.data?.info?.list || [];

        const mapped = list.map((item) => ({
          txId: item.txId,
          ts: item.requestDate,
          amount: item.amount,
          narration: item.remark,
          status: item.statusText,
        }));

        setWithdrawals(mapped);
      } catch (error) {
        console.error("Error fetching withdraw history:", error);
        alert("Failed to load withdraw history");
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawals();
  }, []);

  return (
    <div className="mainhome-screen-wrapper">
      <div className="history-page">
        <AppHeader
          title="Withdraw History"
          walletBalance={walletBalance}
          onBack={() => navigate(-1)}
          onWalletClick={() => navigate("/passbook")}
        />

        <div className="history-body">
          {loading ? (
            <p className="loading">Loading...</p>
          ) : withdrawals.length === 0 ? (
            <p className="empty">No withdraw history found.</p>
          ) : (
            withdrawals.map((item) => (
              <div className="history-item" key={item.txId}>
                <div className="history-row">
                  <span className="timestamp">{item.ts}</span>
                  <span className="statuus">
                    <span className="check">✔</span> {item.status}
                  </span>
                </div>

                <hr />

                <div className="history-row">
                  <span className="label">Amount</span>
                  <span className="value amount">₹ {item.amount}</span>
                </div>

                <div className="history-row">
                  <span className="label">Narration</span>
                  <span className="value narration">{item.narration}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}